export const LOAD_MILK_WIDGET_VALUE = "[DASHBOARD] LOAD_MILK_WIDGET_VALUE";
